import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { CookieConsentLinkItemBlockConfig } from '@front-platform/content-builder';
import { cookieConsentLinkItemBlockResolveConfig } from '@front-platform/content-builder';
import { Component, input } from '@angular/core';

declare const cookieconsent: any;

declare const window: any;
export interface CookieConsentLinkItemBlockRuntimeConfig {}

export type CookieConsentLinkItemBlockConfigInput = Partial<
  Omit<CookieConsentLinkItemBlockConfig, keyof CookieConsentLinkItemBlockRuntimeConfig> &
    CookieConsentLinkItemBlockRuntimeConfig
>;
export type CookieConsentLinkItemBlockResolvedConfig = Omit<
  CookieConsentLinkItemBlockConfig,
  keyof CookieConsentLinkItemBlockRuntimeConfig
> &
  Partial<CookieConsentLinkItemBlockRuntimeConfig>;
export interface CookieConsentLinkItemBlockContract extends ConfigComponentContract<
  CookieConsentLinkItemBlockConfigInput,
  CookieConsentLinkItemBlockResolvedConfig
> {}

@Component({
  selector: 'app-cookie-consent-link-item-block',
  templateUrl: './cookie-consent-link-item-block.component.html',
  standalone: false,
})
export class CookieConsentLinkItemBlockComponent implements CookieConsentLinkItemBlockContract {
  readonly config = input<CookieConsentLinkItemBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    CookieConsentLinkItemBlockConfig,
    CookieConsentLinkItemBlockRuntimeConfig
  >(cookieConsentLinkItemBlockResolveConfig, () => ({ config: this.config() }));
  get label(): string {
    return this.resolvedConfig()['label'] as unknown as string;
  }
  get type(): string {
    return this.resolvedConfig()['type'] as unknown as string;
  }

  openPreferencesCenter(): void {
    cookieconsent.openPreferencesCenter();
  }

  openCookieConsent(): void {
    this.deleteAllCookies();
    cookieconsent.run(window.cookieConsentConfig);
  }

  private getCookies(): { name: string; value: string }[] {
    const cookies: { name: string; value: string }[] = [];

    document.cookie.split(';').forEach(cookie => {
      const [name, value] = cookie.split('=').map(c => c.trim());
      cookies.push({ name, value });
    });

    return cookies;
  }

  private deleteCookie(name: string): void {
    const date = new Date();
    date.setTime(date.getTime() - 1);
    const expires = `;expires=${date.toUTCString()}`;
    document.cookie = `${name}=;${expires};path=/`;
  }

  deleteAllCookies(): void {
    const cookiesToDelete = [
      'cookie_consent_level',
      'cookie_consent_user_consent_token',
      'cookie_consent_user_accepted',
    ];
    const cookies = this.getCookies();

    cookies.forEach(cookie => {
      if (cookiesToDelete.includes(cookie.name)) {
        this.deleteCookie(cookie.name);
      }
    });
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(CookieConsentLinkItemBlockComponent, {
  'keyAliases': {},
});
